<template>
  <div class="mb-4">
    <div class="flex text-white">
      <div
        class="flex w-full items-top mb-3 text-vice-dark-grey gap-2.5"
        :class="{ 'flex-row-reverse': isMe }"
      >
        <div
          class="flex-grow rounded-lg p-2 text-sm"
          :class="{
            'bg-vice-light-grey': !isMe,
            ' bg-vice-easy-gray text-vice-dark-gray': isMe,
            'flex-grow': snapshotData.thumbnail,
          }"
        >
          <!-- Clinician name, date -->
          <div class="mb-1">
            <span class="font-bold mr-2">{{ snapshotData.device_type }}</span>
            {{ formatedDate }}
          </div>

          <div class="flex flex-col">
            <div class="flex items-center">
              <span class="font-medium flex text-vice-dark-grey text-xxs mr-2">
                ({{ snapshotData.metadata.width }}x{{ snapshotData.metadata.height }})
              </span>
            </div>

            <div class="h-40">
              <div @click="attachmentPreviewOpen = true">
                <img
                  class="w-full rounded-lg overflow-hidden mb-2 block cursor-pointer"
                  :src="snapshotData.url"
                  alt=""
                  v-if="snapshotData.thumbnail"
                />
              </div>

              <button
                class="relative left-2 bottom-10 z-20 text-white"
                title="Remove snapshot"
                @click="
                  $emit('removeSnapshot', snapshotData.id);
                  isLoading = true;
                "
              >
                <ViceLoader v-if="isLoading" class="relative ml-1 h-8 w-8" />
                <TrashIcon v-else class="h-6 w-6 shadow-filter" />
              </button>
            </div>

            <a
              class="py-2 flex items-center"
              :href="snapshotData.url"
              v-if="!snapshotData.thumbnail"
              target="_blank"
            >
              <span class="inline-flex"><DocumentDownloadIcon class="w-6 h-6 mr-1" /></span>
              <span class="underline break-all">
                {{ snapshotData.device_type }}
              </span>
            </a>
          </div>
        </div>
      </div>

      <TransitionRoot as="template" :show="attachmentPreviewOpen">
        <Dialog as="div" class="relative z-30" @close="attachmentPreviewOpen = false">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <div class="fixed inset-0 bg-black bg-opacity-70 transition-opacity" />
          </TransitionChild>

          <div class="fixed inset-0 z-10 overflow-y-auto">
            <div
              class="
                flex
                min-h-full
                items-end
                justify-center
                p-4
                text-center
                sm:items-center
                sm:p-0
              "
            >
              <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enter-to="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leave-from="opacity-100 translate-y-0 sm:scale-100"
                leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel
                  class="
                    relative
                    transform
                    overflow-hidden
                    rounded-lg
                    bg-white
                    px-4
                    pt-5
                    pb-4
                    text-left
                    shadow-xl
                    transition-all
                    max-h-screen
                    sm:my-8
                    sm:max-w-7xl
                    sm:p-6
                  "
                >
                  <img
                    class="w-full max-h-screen rounded overflow-hidden my-2 block object-contain"
                    :src="snapshotData.url"
                    alt=""
                  />
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import dayjs from 'dayjs';
import { DocumentDownloadIcon, TrashIcon } from '@heroicons/vue/solid';
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { VICE_SESSION_PHASES } from '@/Utils/vice-constants';
import ViceLoader from '@/Components/Loaders/ViceLoader.vue';

export default {
  components: {
    ViceLoader,
    TrashIcon,
    Dialog,
    DialogPanel,
    TransitionRoot,
    TransitionChild,
    DocumentDownloadIcon,
  },

  props: {
    snapshotData: {
      required: true,
    },
    clinicianName: {
      type: String,
    },
  },
  data: () => ({
    systemMessages: {
      introduction: 1,
      consultation: 2,
      debrief: 3,
    },
    attachmentPreviewOpen: false,
  }),
  setup() {
    const isLoading = ref(false);
    return { isLoading, VICE_SESSION_PHASES };
  },
  computed: {
    isMe() {
      return this.userId === this.messageData?.sender?.id;
    },
    formatedDate() {
      return dayjs(this.snapshotData.captured_at).format('HH:mm');
    },
  },
};
</script>

<style></style>
